import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { FLAW_OPTIONS } from '@/pages/Onboarding/options/Flaw/FLAW_OPTIONS';
import { getFlawTitleById } from '@/pages/Onboarding/options/Flaw/utils/getFlaw';
import { OnbOptionType } from '@/pages/Onboarding/types.ts';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const FlawScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Flaw',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const flaw = form.watch('flaw');

  const handleSelect = (option: OnbOptionType<LayoutDataType['flaw']>) => {
    form.setValue('flaw', option.id);
  };

  const handleNextStep = () => {
    const flawTitle = getFlawTitleById(flaw);
    userService.createOrUpdate({
      onboarding_data: {
        flaw: flawTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation showSkip />
      <OwnAiTitle>Give Him a Little Flaw</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {FLAW_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={flaw === option.id}
              control={form.control}
              option={option}
              name="flaw"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!flaw}
      />
    </OnboardingPage>
  );
};
